import { computedFrom } from 'aurelia-framework';
import { DeviceMetadata } from "./device-metadata";
import { Property } from "./property";

export class Device {
	id: string;
	deviceId: string;
	deviceStyle: string = "";
	deviceTypeIds: Array<string>;
	styles: any = {};
	properties: any;
	messages: any = {};
	data: any = {};
	name: string;
	metadata: DeviceMetadata;
	children: Array<Device>;
	deviceProperties: Array<Property>;
	parentId: string;

	@computedFrom('data')
	get hasData():boolean {
		return (this.data !== undefined && this.data !== "undefined" && this.data !== null);
	}

	@computedFrom('children')
	get hasChildren(): boolean {
		return (this.children !== undefined && this.children !== null && this.children.length > 0);

	}

	@computedFrom('messages')
	get hasWarnings(): boolean {
		return (this.messages !== undefined && this.messages !== "undefined" && this.messages !== null && this.messages.length > 0);
	}

	@computedFrom('properties')
	get hasProperties(): boolean {
		return (this.properties !== undefined && this.properties !== null);
	}

	@computedFrom('styles')
	get hasStyles(): boolean {
		return (this.styles !== undefined && this.styles !== "undefined" && this.styles !== null);
	}
}

